import { RemoteSemanticInterpreter } from './remoteInterpreter'
import { ResilientSemanticInterpreter } from './resilientInterpreter'
import { StubSemanticInterpreter } from './stubInterpreter'
import type { SemanticInterpreter } from './types'

/**
 * The submission defaults to the deterministic stub and makes no network call.
 * If organizers approve runtime LLM use, setting VITE_LLM_ENDPOINT swaps in a
 * schema-checked proxy while retaining the stub as timeout/error fallback.
 */
export function createSemanticInterpreter(): SemanticInterpreter {
  const stub = new StubSemanticInterpreter()
  const endpoint = import.meta.env.VITE_LLM_ENDPOINT?.trim()

  if (!endpoint) return stub
  return new ResilientSemanticInterpreter(
    new RemoteSemanticInterpreter(endpoint),
    stub,
  )
}
